/* ==========================================================================
  main.js
========================================================================== */

/**
 * Navigation
 */
aucor_navigation(document.getElementById('primary-navigation'), {
	desktop_min_width: 992, // min width in pixels
	menu_toggle: '#menu-toggle' // selector for toggle
});

/**
 * Responsive videos
 */
fitvids();


// add jquery as dependency in functions.php and uncomment the following if you need jquery
//
(function ($) {
	$(document).ready(function () {

		//Preloader

		$(window).load(function () {
			$('#preloader').fadeOut('slow', function () {
				$(this).remove();
			});
		});


		// Header scroll

		var $navbar = $('.site-header');

		var $offsetY = $navbar.offset().top + 1;

		function scroll() {

			if ($(window).scrollTop() >= $offsetY) {
				$navbar.addClass('menu-fixed');
			} else {
				$navbar.removeClass('menu-fixed');
			}
		}

		document.onscroll = scroll;


		//rectangle mouse slide
		$('#rectangle').on('click', function () {
			var targetMouse = $('#aktualnosci');
			$('html, body').animate({
				scrollTop: targetMouse.offset().top - 120
			}, 1000);
		});


		//menu slide to target
		$('a[href*=#]:not([href=#])').click(function () {
			if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				if (target.length) {
					$('html,body').animate({
						scrollTop: target.offset().top - 120
					}, 1000);
					return false;
				}
			}
		});


		// Slider Aktualnosci

		var newsOwl = $(".news__container.owl-carousel");
		newsOwl.owlCarousel({
			items: 1,
			autoplay: true,
			autoplayTimeout: 10000,
			margin: 30,
			loop: true,
			smartSpeed: 1500,
			dots: false,
			owl2row: 'true',
			owl2rowTarget: 'item',
			responsive: {
				0: {
					nav: false
				},
				768: {
					nav: true,
					items: 2
				}
			}
		});

		$('.news__box-border_v').css('margin-bottom', '0');

		// Slider Osiągnięcia
		var achievementOwl = $(".achievement__container.owl-carousel");
		achievementOwl.owlCarousel({
			items: 1,
			autoplay: true,
			autoplayTimeout: 10000,
			margin: 50,
			loop: true,
			smartSpeed: 1500,
			nav: true,
			dots: false,
			responsive: {
				768: {
					nav: true,
					items: 2
				},
				992: {
					nav: true,
					items: 3
				}
			}
		});


		// Accordion

		var acc = document.getElementsByClassName("accordion");
		var i;

		for (i = 0; i < acc.length; i++) {
			acc[i].addEventListener("click", function () {
				this.classList.toggle("active");
				var panel = this.nextElementSibling;
				if (panel.style.maxHeight) {
					panel.style.maxHeight = null;
				} else {
					panel.style.maxHeight = panel.scrollHeight + "px";
				}
			});
		}

		// Tabsy usługi

		$("#tabs-uslugi").tabs();

		// matchHeight

		$('.height').matchHeight();


		// Wyświetlenie modali aktualności

		var modalLink = $('.modal__link'),
			modalNews = $('.modal-news');

		modalLink.on('click', function (e) {

			e.preventDefault();

			var modalTitle = e.target.title,
				modalText = e.target.getAttribute('data-modaltext'),
				modalData = e.target.getAttribute('data-modaldata'),
				modalData2 = e.target.getAttribute('data-modaldata2'),
				modalPublic = e.target.getAttribute('data-publikacji'),
				modalSeed = e.target.getAttribute('data-seed'),
				modalAutor = e.target.getAttribute('data-autor');

			modalNews.each(function () {
				($(this).html('<span class="close__modal">&times;</span><article class="row news__box"><time class="col-3 col-md-2 news__date"><h2>' + modalData + '</h2><span>' + modalData2 + '</span></time><div class="col-8 col-md-9 news_content"><h5 class="news__title">' + modalTitle + '</h5>' + 'Data publikacji: ' + modalPublic + '<br>Autor: ' + modalAutor + '<br>Żródło: ' + modalSeed + '<br><br>' + modalText + '</div></article>'));
				($(this).addClass('current'));

				$('.close__modal').on('click', function () {

					modalNews.removeClass('current');

				});

			});

		});

		// Wyświetlenie modali Zespół

		var teamItem = $('.team__item'),
			modal = $('.modal');

		teamItem.on('click', function (e) {

			console.log('click');

			e.preventDefault();

			var teamName = e.target.title;
			var teamImage = e.target.title;

			modal.each(function () {

				if (($(this).attr('data-modal')) == teamName) {

					($(this).addClass('current'));

				} else {

					($(this).removeClass('current'));

				}

			});

		});


		$('.close__modal').on('click', function () {

			modal.removeClass('current');

		});

		// Wyświetlenie tabsów osiągnięcia

		var tabItem = $('.tab__link'),
			tabContent = $('.tab__content');

		tabItem.on('click', function (e) {

			e.preventDefault();

			var tabName = e.target.title;

			var tabText = e.target.getAttribute('data-tabtext');

			tabContent.each(function () {
				($(this).html('<h5 class="tab__title news__title-gold tab__con">' + tabName + '</h5>' + tabText));
			});

		});


		// Animacje

		window.sr = new ScrollReveal();

		sr.reveal('.animate_bottom', {
			duration: 1200,
			origin: 'bottom',
			distance: '300px'
		}, 0);
		sr.reveal('.animate_right', {
			duration: 1200,
			origin: 'right',
			distance: '200px'
		}, 500);
		sr.reveal('.animate_left', {
			duration: 1200,
			origin: 'left',
			distance: '300px'
		}, 500);
		sr.reveal('.animate_show', {
			duration: 1200,
			ease: 'cubic-bezier(0.5, 0, 0, 1)'
		}, 500);
	});

})(jQuery);

/**
 * Polyfill object-fit for lazyloaded
 */
if (typeof objectFitPolyfill === "function") {
	document.addEventListener('lazybeforeunveil', function (e) {

		// current <img> element
		var el = e.target;

		objectFitPolyfill();
		el.addEventListener('load', function () {
			objectFitPolyfill();
		});

	});
}
